import { a as x } from "./index-DIyqYqBT.js";
const f = /\{[^{}]+\}/g, h = ({
  allowReserved: e,
  name: l,
  value: c
}) => {
  if (c == null)
    return "";
  if (typeof c == "object")
    throw new Error(
      "Deeply-nested arrays/objects aren’t supported. Provide your own `querySerializer()` to handle these."
    );
  return `${l}=${e ? c : encodeURIComponent(c)}`;
}, A = (e) => {
  switch (e) {
    case "label":
      return ".";
    case "matrix":
      return ";";
    case "simple":
      return ",";
    default:
      return "&";
  }
}, R = (e) => {
  switch (e) {
    case "form":
      return ",";
    case "pipeDelimited":
      return "|";
    case "spaceDelimited":
      return "%20";
    default:
      return ",";
  }
}, y = (e) => {
  switch (e) {
    case "label":
      return ".";
    case "matrix":
      return ";";
    case "simple":
      return ",";
    default:
      return "&";
  }
}, L = ({
  allowReserved: e,
  explode: l,
  name: c,
  style: u,
  value: s
}) => {
  if (!l) {
    const t = (e ? s : s.map((d) => encodeURIComponent(d))).join(R(u));
    switch (u) {
      case "label":
        return `.${t}`;
      case "matrix":
        return `;${c}=${t}`;
      case "simple":
        return t;
      default:
        return `${c}=${t}`;
    }
  }
  const n = A(u), a = s.map((t) => u === "label" || u === "simple" ? e ? t : encodeURIComponent(t) : h({
    allowReserved: e,
    name: c,
    value: t
  })).join(n);
  return u === "label" || u === "matrix" ? n + a : a;
}, P = ({
  allowReserved: e,
  explode: l,
  name: c,
  style: u,
  value: s
}) => {
  if (u !== "deepObject" && !l) {
    let t = [];
    Object.entries(s).forEach(([g, m]) => {
      t = [
        ...t,
        g,
        e ? m : encodeURIComponent(m)
      ];
    });
    const d = t.join(",");
    switch (u) {
      case "form":
        return `${c}=${d}`;
      case "label":
        return `.${d}`;
      case "matrix":
        return `;${c}=${d}`;
      default:
        return d;
    }
  }
  const n = y(u), a = Object.entries(s).map(
    ([t, d]) => h({
      allowReserved: e,
      name: u === "deepObject" ? `${c}[${t}]` : t,
      value: d
    })
  ).join(n);
  return u === "label" || u === "matrix" ? n + a : a;
}, w = ({ path: e, url: l }) => {
  let c = l;
  const u = l.match(f);
  if (u)
    for (const s of u) {
      let n = !1, a = s.substring(1, s.length - 1), t = "simple";
      a.endsWith("*") && (n = !0, a = a.substring(0, a.length - 1)), a.startsWith(".") ? (a = a.substring(1), t = "label") : a.startsWith(";") && (a = a.substring(1), t = "matrix");
      const d = e[a];
      if (d != null) {
        if (Array.isArray(d)) {
          c = c.replace(
            s,
            L({ explode: n, name: a, style: t, value: d })
          );
          continue;
        }
        if (typeof d == "object") {
          c = c.replace(
            s,
            P({
              explode: n,
              name: a,
              style: t,
              value: d
            })
          );
          continue;
        }
        if (t === "matrix") {
          c = c.replace(
            s,
            `;${h({
              name: a,
              value: d
            })}`
          );
          continue;
        }
        c = c.replace(
          s,
          t === "label" ? `.${d}` : d
        );
      }
    }
  return c;
}, T = ({
  path: e,
  url: l
}) => e ? w({ path: e, url: l }) : l, b = (e, l) => {
  const c = { ...e, ...l };
  return c.headers = C(e.headers, l.headers), c;
}, C = (...e) => {
  const l = {};
  for (const c of e) {
    if (!c || typeof c != "object")
      continue;
    const u = Object.entries(c);
    for (const [s, n] of u)
      if (n === null)
        delete l[s];
      else if (Array.isArray(n))
        for (const a of n)
          l[s] = [...l[s] ?? [], a];
      else n !== void 0 && (l[s] = typeof n == "object" ? JSON.stringify(n) : n);
  }
  return l;
}, _ = (e = {}) => ({
  baseURL: "",
  ...e
}), E = (e) => {
  let l = b(_(), e);
  const c = x.create(l), u = () => ({ ...l }), s = (a) => (l = b(l, a), c.defaults = {
    ...c.defaults,
    ...l,
    // @ts-ignore
    headers: C(c.defaults.headers, l.headers)
  }, u()), n = async (a) => {
    var m;
    const t = {
      ...l,
      ...a,
      // @ts-ignore
      headers: C(l.headers, a.headers)
    };
    t.body && t.bodySerializer && (t.body = t.bodySerializer(t.body));
    const d = T({
      path: t.path,
      url: t.url
    }), g = t.axios || c;
    try {
      const i = await g({
        ...t,
        data: t.body,
        params: t.query,
        url: d
      });
      let { data: v } = i;
      return t.responseType === "json" && t.responseTransformer && (v = await t.responseTransformer(v)), {
        ...i,
        data: v ?? {}
      };
    } catch (i) {
      const v = i;
      if (t.throwOnError)
        throw v;
      return v.error = ((m = v.response) == null ? void 0 : m.data) ?? {}, v;
    }
  };
  return {
    delete: (a) => n({ ...a, method: "delete" }),
    get: (a) => n({ ...a, method: "get" }),
    getConfig: u,
    head: (a) => n({ ...a, method: "head" }),
    instance: c,
    options: (a) => n({ ...a, method: "options" }),
    patch: (a) => n({ ...a, method: "patch" }),
    post: (a) => n({ ...a, method: "post" }),
    put: (a) => n({ ...a, method: "put" }),
    request: n,
    setConfig: s
  };
}, r = E(_()), I = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/account/"
}), j = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/account/account/{account_id}/"
}), S = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/account/accounts/"
}), D = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/address/address/{address_id}/near-objects/"
}), O = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/address/select/"
}), k = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/address/suggestion/"
}), $ = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/analytics/analytics/"
}), F = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/application/admin/applications/"
}), G = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/application/cancel-or-complete/"
}), z = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/application/cancel-or-complete/{application_id}/"
}), M = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/application/council/applications/"
}), q = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/application/create/"
}), B = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/application/files/{application_id}/"
}), N = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/application/files/{application_id}/{id}/"
}), V = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/application/list/"
}), H = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/application/retrieve/{application_id}/"
}), W = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/application/upload-file/{application_id}/"
}), J = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/assessment/assessment-review-state-definition/"
}), K = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/assessment/conversation/{conversation_id}/assessment-review-state/{assessment_review_id}/"
}), Q = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/assessment/conversation/{conversation_id}/assessment-review-states/"
}), X = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/assessment/conversation/{conversation_id}/assessment-review-states/"
}), Y = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/assessment/issue-category/"
}), Z = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/assessment/issue-category/"
}), p = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/assessment/issue-category/{issue_category_id}/"
}), o = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/assessment/issue-category/{issue_category_id}/"
}), ee = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/assessment/issue/{issue_id}/"
}), re = (e) => ((e == null ? void 0 : e.client) ?? r).patch({
  ...e,
  url: "/assessment/issue/{issue_id}/"
}), ae = (e) => ((e == null ? void 0 : e.client) ?? r).patch({
  ...e,
  url: "/assessment/issue/{issue_id}/resolve/"
}), te = (e) => ((e == null ? void 0 : e.client) ?? r).patch({
  ...e,
  url: "/assessment/issue/{issue_id}/unresolve/"
}), ce = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/assessment/issues/"
}), le = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/assessment/issues/"
}), ne = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/auth/login/"
}), ue = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/auth/logout/"
}), se = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/auth/logout/"
}), de = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/auth/password/change/"
}), ve = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/auth/password/reset/"
}), me = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/auth/password/reset/confirm/"
}), ie = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/auth/password/reset/confirm/{uid}/{token}/"
}), ge = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/auth/registration/"
}), Ce = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/auth/registration/resend-email/"
}), he = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/auth/registration/verify-email/"
}), be = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/auth/social/"
}), _e = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/auth/sso/"
}), xe = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/auth/test/"
}), fe = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/auth/user/"
}), Ae = (e) => ((e == null ? void 0 : e.client) ?? r).put({
  ...e,
  url: "/auth/user/"
}), Re = (e) => ((e == null ? void 0 : e.client) ?? r).patch({
  ...e,
  url: "/auth/user/"
}), ye = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/conversation/admin/conversation/expert_result/revise/"
}), Le = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/conversation/admin/conversation/panel-test-execution/{execution_id}/update-feedback-result/"
}), Pe = (e) => ((e == null ? void 0 : e.client) ?? r).patch({
  ...e,
  url: "/conversation/admin/conversation/panel-test/{test_conversation_expert_result_id}/update-feedback-result/"
}), we = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/conversation/admin/conversation/test/group/"
}), Te = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/conversation/admin/conversation/test/group/{group_id}/"
}), Ee = (e) => ((e == null ? void 0 : e.client) ?? r).patch({
  ...e,
  url: "/conversation/admin/conversation/test/group/{group_id}/"
}), Ue = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/conversation/admin/conversation/test/groups/"
}), Ie = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/conversation/admin/conversation/test/panel/"
}), je = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/conversation/admin/conversation/test/panel/{panel_id}/"
}), Se = (e) => ((e == null ? void 0 : e.client) ?? r).patch({
  ...e,
  url: "/conversation/admin/conversation/test/panel/{panel_id}/"
}), De = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/conversation/admin/conversation/test/panel/{panel_id}/results/"
}), Oe = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/conversation/admin/conversation/test/panel/{panel_id}/results/grouped/"
}), ke = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/conversation/admin/conversation/test/panel/{panel_id}/run/"
}), $e = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/conversation/admin/conversation/test/panels/"
}), Fe = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/conversation/admin/conversation/{conversation_id}/change_panel/"
}), Ge = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/conversation/admin/conversation/{conversation_id}/execution-graph/{message_number}/{iteration}/"
}), ze = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/conversation/admin/conversation/{conversation_id}/executions/"
}), Me = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/conversation/admin/conversation/{conversation_id}/expert_results/"
}), qe = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/conversation/admin/conversation/{conversation_id}/new-message/"
}), Be = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/conversation/admin/conversation/{conversation_id}/set_test_conversation_expert_execution_as_live/"
}), Ne = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/conversation/admin/conversations/"
}), Ve = (e) => ((e == null ? void 0 : e.client) ?? r).patch({
  ...e,
  url: "/conversation/admin/conversations/"
}), He = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/conversation/admin/conversations/{conversation_id}/"
}), We = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/conversation/admin/conversations/{conversation_id}/send_to_council/"
}), Je = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/conversation/admin/create-evaluation-from-expert-result/"
}), Ke = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/conversation/admin/deployment/conversation/"
}), Qe = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/conversation/admin/deployment/conversation/{conversation_id}/"
}), Xe = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/conversation/application/{application_id}/conversation/"
}), Ye = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/conversation/application/{application_id}/conversation/{conversation_id}/"
}), Ze = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/conversation/application/{application_id}/conversation/{conversation_id}/message/"
}), pe = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/conversation/application/{application_id}/conversation/{conversation_id}/messages/"
}), oe = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/conversation/application/{application_id}/conversations/"
}), er = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/conversation/conversation/{conversation_id}/"
}), rr = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/conversation/conversation/{conversation_id}/save_report/"
}), ar = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/conversation/conversations/"
}), tr = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/conversation/conversations/{conversation_id}/notes/"
}), cr = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/conversation/conversations/{conversation_id}/notes/"
}), lr = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/conversation/conversations/{conversation_id}/reviews/"
}), nr = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/conversation/conversations/{conversation_id}/reviews/"
}), ur = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/conversation/council/conversations/"
}), sr = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/conversation/council/conversations/{conversation_id}/"
}), dr = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/conversation/panels/"
}), vr = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/conversation/public/conversation/{conversation_identifier}/"
}), mr = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/conversation/test-conversaton/create/"
}), ir = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/conversation/{conversation_id}/messages/{message_id}/graph/"
}), gr = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/council/annotations-by-title/"
}), Cr = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/council/bulk-create-council-ordinance"
}), hr = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/council/council-ordinances"
}), br = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/council/council-ordinances"
}), _r = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/council/council/{council_id}/"
}), xr = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/council/council/{council_id}/member/create/"
}), fr = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/council/council/{council_id}/member/{account_id}/"
}), Ar = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/council/councils"
}), Rr = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/council/councils"
}), yr = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/council/create-council-ordinance"
}), Lr = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/council/enquiry-topics/{council_code}/"
}), Pr = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/council/table-of-uses-sections"
}), wr = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/council/table-of-uses-sections"
}), Tr = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/council/{council_code}/annotations/"
}), Er = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/council/{council_code}/clause/{clause_number}/annotations/"
}), Ur = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/council/{council_code}/clause/{clause_number}/annotations/"
}), Ir = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/dashboard/auth/login/"
}), jr = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/dashboard/auth/logout/"
}), Sr = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/dashboard/auth/logout/"
}), Dr = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/dashboard/auth/password/change/"
}), Or = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/dashboard/auth/password/reset/"
}), kr = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/dashboard/auth/password/reset/confirm/"
}), $r = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/dashboard/auth/password/reset/confirm/{uid}/{token}/"
}), Fr = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/dashboard/auth/registration/"
}), Gr = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/dashboard/auth/registration/resend-email/"
}), zr = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/dashboard/auth/registration/verify-email/"
}), Mr = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/dashboard/auth/social/"
}), qr = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/dashboard/auth/sso/"
}), Br = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/dashboard/auth/test/"
}), Nr = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/dashboard/auth/user/"
}), Vr = (e) => ((e == null ? void 0 : e.client) ?? r).put({
  ...e,
  url: "/dashboard/auth/user/"
}), Hr = (e) => ((e == null ? void 0 : e.client) ?? r).patch({
  ...e,
  url: "/dashboard/auth/user/"
}), Wr = (e) => ((e == null ? void 0 : e.client) ?? r).patch({
  ...e,
  url: "/evaluation/evaluation-result-feedback/{evaluation_result_id}/"
}), Jr = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/expert/compare-experts/"
}), Kr = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/expert/compare-panels/"
}), Qr = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/expert/context-cutter/{context_cutter_id}/"
}), Xr = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/expert/context-cutter/{cutter_or_step_id}/get_experts"
}), Yr = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/expert/context-cutters/"
}), Zr = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/expert/council/{council_id}/set_default_panel/{panel_id}"
}), pr = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/expert/deployment/batch-create-context-cutter/"
}), or = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/expert/deployment/batch-create-expert/"
}), ea = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/expert/deployment/batch-create-llm-model/"
}), ra = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/expert/deployment/create-expert/"
}), aa = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/expert/deployment/create-panel/"
}), ta = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/expert/deployment/panel/set-council-panel-in-environment/"
}), ca = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/expert/deployment/panel/{panel_id}/create-panel-in-environment/"
}), la = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/expert/deployment/panel/{panel_id}/initiate-set-council-panel-in-environment/"
}), na = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/expert/expert-config-types/"
}), ua = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/expert/expert/{expert_id}/full-prompt/"
}), sa = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/expert/experts-list/"
}), da = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/expert/llm_providers/"
}), va = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/expert/panels/"
}), ma = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/expert/panels/"
}), ia = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/expert/panels/set_archive/{panel_version}/{archive}/"
}), ga = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/expert/panels/{panel_id}/"
}), Ca = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/expert/panels/{panel_id}/graph/"
}), ha = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/rap/applications/rules/reorder/"
}), ba = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/rap/controls/reorder/"
}), _a = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/rap/templates/rules/reorder/"
}), xa = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/utils/command-center-data-fetch/"
}), fa = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/utils/content-type/"
}), Aa = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/utils/healthcheck/"
}), Ra = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/utils/tag/"
}), ya = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/utils/tag/"
}), La = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/utils/tag/{id}/"
}), Pa = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/utils/tagged-item/"
}), wa = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/utils/tagged-item/"
}), Ta = (e) => ((e == null ? void 0 : e.client) ?? r).get({
  ...e,
  url: "/utils/tagged-item/{id}/"
}), Ea = (e) => ((e == null ? void 0 : e.client) ?? r).put({
  ...e,
  url: "/utils/tagged-item/{id}/"
}), Ua = (e) => ((e == null ? void 0 : e.client) ?? r).delete({
  ...e,
  url: "/utils/tagged-item/{id}/"
}), Ia = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/vendor/webhook/linear/"
}), ja = (e) => ((e == null ? void 0 : e.client) ?? r).post({
  ...e,
  url: "/vendor/webhook/linear/issues/"
});
export {
  Ee as $,
  ee as A,
  re as B,
  ae as C,
  te as D,
  ce as E,
  le as F,
  ne as G,
  ue as H,
  se as I,
  de as J,
  ve as K,
  me as L,
  ie as M,
  ge as N,
  Ce as O,
  he as P,
  be as Q,
  _e as R,
  xe as S,
  fe as T,
  Ae as U,
  Re as V,
  ye as W,
  Le as X,
  Pe as Y,
  we as Z,
  Te as _,
  I as a,
  Gr as a$,
  Ue as a0,
  Ie as a1,
  je as a2,
  Se as a3,
  De as a4,
  Oe as a5,
  ke as a6,
  $e as a7,
  Fe as a8,
  Ge as a9,
  vr as aA,
  mr as aB,
  ir as aC,
  gr as aD,
  Cr as aE,
  hr as aF,
  br as aG,
  _r as aH,
  xr as aI,
  fr as aJ,
  Ar as aK,
  Rr as aL,
  yr as aM,
  Lr as aN,
  Pr as aO,
  wr as aP,
  Tr as aQ,
  Er as aR,
  Ur as aS,
  Ir as aT,
  jr as aU,
  Sr as aV,
  Dr as aW,
  Or as aX,
  kr as aY,
  $r as aZ,
  Fr as a_,
  ze as aa,
  Me as ab,
  qe as ac,
  Be as ad,
  Ne as ae,
  Ve as af,
  He as ag,
  We as ah,
  Je as ai,
  Ke as aj,
  Qe as ak,
  Xe as al,
  Ye as am,
  Ze as an,
  pe as ao,
  oe as ap,
  er as aq,
  rr as ar,
  ar as as,
  tr as at,
  cr as au,
  lr as av,
  nr as aw,
  ur as ax,
  sr as ay,
  dr as az,
  j as b,
  zr as b0,
  Mr as b1,
  qr as b2,
  Br as b3,
  Nr as b4,
  Vr as b5,
  Hr as b6,
  Wr as b7,
  Jr as b8,
  Kr as b9,
  Aa as bA,
  Ra as bB,
  ya as bC,
  La as bD,
  Pa as bE,
  wa as bF,
  Ta as bG,
  Ea as bH,
  Ua as bI,
  Ia as bJ,
  ja as bK,
  Qr as ba,
  Xr as bb,
  Yr as bc,
  Zr as bd,
  pr as be,
  or as bf,
  ea as bg,
  ra as bh,
  aa as bi,
  ta as bj,
  ca as bk,
  la as bl,
  na as bm,
  ua as bn,
  sa as bo,
  da as bp,
  va as bq,
  ma as br,
  ia as bs,
  ga as bt,
  Ca as bu,
  ha as bv,
  ba as bw,
  _a as bx,
  xa as by,
  fa as bz,
  r as c,
  S as d,
  D as e,
  O as f,
  k as g,
  $ as h,
  F as i,
  G as j,
  z as k,
  M as l,
  q as m,
  B as n,
  N as o,
  V as p,
  H as q,
  W as r,
  J as s,
  K as t,
  Q as u,
  X as v,
  Y as w,
  Z as x,
  p as y,
  o as z
};
//# sourceMappingURL=services.gen-D7DK4RCL.js.map
